var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { delay } from '@xyo-network/sdk-xyo-js';
import { GoogleCustomEvent, GoogleStandardEvents, Gtag } from '@xyo-network/sdk-xyo-react-js';
class GoogleEvents extends GoogleStandardEvents {
    pageView(page_path) {
        return __awaiter(this, void 0, void 0, function* () {
            Gtag.instance.updatePagePath(page_path);
            yield delay(0);
        });
    }
    contactInfoComplete() {
        return new GoogleCustomEvent('ContactInfoComplete', 'wStWCNWE1-8BEOjZhtgD');
    }
    addressInfoComplete() {
        return new GoogleCustomEvent('AddressInfoComplete', 'b119CLj8lPABEOjZhtgD');
    }
    paymentInfoComplete() {
        return new GoogleCustomEvent('PaymentInfoComplete', 'EvwsCLGh9e8BEOjZhtgD');
    }
    transactionAttempted() {
        return new GoogleCustomEvent('TransactionAttempted');
    }
    transactionFailed() {
        return new GoogleCustomEvent('TransactionFailed');
    }
    transactionCompleted() {
        return new GoogleCustomEvent('TransactionCompleted', 'Sw3uCICj9e8BEOjZhtgD');
    }
    upsellViewed() {
        return new GoogleCustomEvent('UpsellViewed');
    }
    upsellUnavailable() {
        return new GoogleCustomEvent('UpsellUnavailable');
    }
    upsellAccepted() {
        return new GoogleCustomEvent('UpsellAccepted');
    }
    upsellSucceeded() {
        return new GoogleCustomEvent('UpsellSucceeded', '8ubgCM6DlfABEOjZhtgD');
    }
    upsellFailed() {
        return new GoogleCustomEvent('UpsellFailed');
    }
    trialStarted() {
        return new GoogleCustomEvent('TrialStarted');
    }
    testStarted() {
        return new GoogleCustomEvent('TestStarted');
    }
    funnelStarted() {
        return new GoogleCustomEvent('FunnelStarted');
    }
    viewContent() {
        return new GoogleCustomEvent('ViewContent');
    }
    userClick() {
        return new GoogleCustomEvent('UserClick');
    }
    emailCollected() {
        return new GoogleCustomEvent('EmailCollected');
    }
    accountCreated() {
        return new GoogleCustomEvent('AccountCreated');
    }
    shareCompleted() {
        return new GoogleCustomEvent('ShareCompleted');
    }
    funnelCompleted() {
        return new GoogleCustomEvent('FunnelCompleted');
    }
    buyticketsCompleted() {
        return new GoogleCustomEvent('BuyTicketsCompleted');
    }
    installCompleted() {
        return new GoogleCustomEvent('InstallCompleted');
    }
    offerRequested() {
        return new GoogleCustomEvent('OfferRequested');
    }
    feedbackScoreCollected() {
        return new GoogleCustomEvent('FeedbackScoreCollected');
    }
    feedbackSourceCollected() {
        return new GoogleCustomEvent('FeedbackSourceCollected');
    }
    goodFeedbackRequested() {
        return new GoogleCustomEvent('GoodFeedbackRequested');
    }
    badFeedbackRequested() {
        return new GoogleCustomEvent('BadFeedbackRequested');
    }
}
export default GoogleEvents;
//# sourceMappingURL=index.js.map